// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__Wkhd3","Textfield":"Homepage_Textfield__ER0R6","main1":"Homepage_main1__ezDVa","next":"Homepage_next__HLNhA"};